import { render, staticRenderFns } from "./OrderContract.vue?vue&type=template&id=123b78de"
import script from "./OrderContract.vue?vue&type=script&lang=js"
export * from "./OrderContract.vue?vue&type=script&lang=js"
import style0 from "./OrderContract.vue?vue&type=style&index=0&id=123b78de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports